import React from "react";

const clientLogos = [
  {
    id: 1,
    name: "Chevron",
    image: "/assets/images/chevron.png",
  },
  {
    id: 2,
    name: "Intels",
    image: "/assets/images/intels2.png",
  },
  {
    id: 3,
    name: "Addax Petroleum",
    image: "/assets/images/addax-petroleum.png",
  },
  {
    id: 4,
    name: "Halliburton",
    image: "/assets/images/halliburton.png",
  },
  {
    id: 5,
    name: "Agip",
    image: "/assets/images/agip.png",
  },
  {
    id: 6,
    name: "Total",
    image: "/assets/images/total.png",
  },
];

const LogoCarousel = () => {
  return (
    <section className="w-full bg-[#f4f4f4] py-8 overflow-hidden">
      <div className="relative w-full overflow-hidden">
        <div className="flex items-center gap-24 animate-logo-scroll whitespace-nowrap">
          {[...clientLogos, ...clientLogos].map((logo, index) => (
            <div
              key={`${logo.id}-${index}`}
              className="flex-shrink-0 h-[95px] w-[150px] flex items-center justify-center"
            >
              <img
                src={logo.image}
                alt={logo.name}
                className="max-h-[90px] max-w-[150px] object-contain"
              />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes logo-scroll {
          0% {
            transform: translateX(0);
          }

          100% {
            transform: translateX(-50%);
          }
        }

        .animate-logo-scroll {
          animation: logo-scroll 18s linear infinite;
        }
      `}</style>
    </section>
  );
};

export default LogoCarousel;